module.exports = __webpack_public_path__ + "static/media/DiseñoPC.7d9ea4be.jpg";